import { render, staticRenderFns } from "./PrimeryKotelnyhEditor.vue?vue&type=template&id=91681448&scoped=true"
import script from "./PrimeryKotelnyhEditor.vue?vue&type=script&lang=js"
export * from "./PrimeryKotelnyhEditor.vue?vue&type=script&lang=js"
import style0 from "./PrimeryKotelnyhEditor.vue?vue&type=style&index=0&id=91681448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91681448",
  null
  
)

export default component.exports